import client from '../request'

const getAll = (data) => {
  return client.get('/announcements')
}

export default {
  getAll
}
